
import { Dealer } from './../../Models/Dealer';
import { AuthenticationResult } from '@azure/msal-browser';
import {
  LoadDealersAction,
  CreateDealerAction,
  CREATE_DEALER,
  LOAD_DEALER,
  createDealerSuccess,
  loadAllDealersSuccess,
  LOAD_ALL_DEALERS,
  loadAllDealerGroupsSuccess,
  LOAD_ALL_DEALER_GROUPS,
  UpdateDealerAction,
  UpdateDealerSuccessAction,
  updateDealerSuccess,
  UPDATE_DEALER,
  CreateDealerGroupAction,
  createDealerGroupSuccess,
  CREATE_DEALER_GROUP,
  UpdateDealerGroupAction,
  updateDealerGroupSuccess,
  UPDATE_DEALER_GROUP,
  AddDealerToDealerGroupAction,
  addDealerToDealerGroupSuccess,
  ADD_DEALER_TO_DEALER_GROUP,
  RemoveDealerFromDealerGroupAction,
  REMOVE_DEALER_FROM_DEALER_GROUP,
  removeDealerFromDealerGroupSuccess,
  updateDealerDealerGroupMemberSuccess,
  UpdateDealerDealerGroupMemberAction,
  UPDATE_DEALER_DEALER_GROUP_MEMBER
} from './actions';

import { put, takeLatest, all, call } from 'redux-saga/effects';
import { authService } from '../../index';
import { httpDelete, httpGet, httpPost, httpPut } from '../../Http/HttpClient';
import { displayError } from '../../Helpers/Utilities';
import { DealerGroup } from '../../Models/DealerGroup';
import { createUser } from '../Admin/actions';
import { User } from '../../Models/User';
import { hasValue } from '@amsanalytics/react-shared-library';



// Load All Dealers
function* loadAllDealersSaga() {
  try {
    const token: string = yield authService.getToken();
    const response: {json: any} = yield call(httpGet,
      `${authService.appSettings.GetWebApiBaseUri()}/client/all`,
      token
    ); 
    const dealers: Dealer[] = yield call([response, response.json]);
    yield put(loadAllDealersSuccess(dealers));
  } catch (error) {
    yield put(displayError(error as string));
  }
}
export function* watchLoadAllDealers() {
  yield takeLatest(LOAD_ALL_DEALERS, loadAllDealersSaga);
}

function* createDealerSaga(action: CreateDealerAction) {
  try {
    const token: string = yield authService.getToken();
    const response: {json: any} = yield call(httpPost, 
      `${authService.appSettings.GetWebApiBaseUri()}/client`,
      action.payload.dealer, 
      token
    );
    const dealer: Dealer = yield call([response, response.json]);
    if(dealer && hasValue(action.payload.dealer.accountCreationInfo?.username)
      && hasValue(action.payload.dealer.accountCreationInfo?.firstName)
      && hasValue(action.payload.dealer.accountCreationInfo?.lastName)
      && hasValue(action.payload.dealer.accountCreationInfo?.emailAddress)
    ) {
      const accountCreationInfo = action.payload.dealer.accountCreationInfo;
      const user: User = {
        clientId: dealer.id,
        adUserId: `${accountCreationInfo!.username!}@amsanalytics.com`,
        firstName: accountCreationInfo!.firstName!,
        lastName: accountCreationInfo!.lastName!,
        emailAddress: accountCreationInfo!.emailAddress!,
        mobilePhone: accountCreationInfo!.phoneNumber!,       
        isSuperUser: false,
        employeeRoleIds: []      
      };
      yield put(createUser(user));      
    }
    yield put(createDealerSuccess(dealer));
  } catch (error) {
    yield put(displayError(error as string));
  }
}
export function* watchCreateDealer() {
  yield takeLatest(CREATE_DEALER, createDealerSaga);
}

// Update Dealer
function* updateDealerSaga(action: UpdateDealerAction) {
  try {
    const token: string = yield authService.getToken();
    const response: {json: any} = yield call(httpPut, 
      `${authService.appSettings.GetWebApiBaseUri()}/client`,
      action.payload.dealer, 
      token
    );
    const dealer: Dealer = yield call([response, response.json]);
    yield put(updateDealerSuccess(dealer));
  } catch (error) {
    yield put(displayError(error as string));
  }
}
export function* watchUpdateDealer() {
  yield takeLatest(UPDATE_DEALER, updateDealerSaga);
}

// Load All Dealer Groups
function* loadAllDealerGroupsSaga() {
  try {
    const token: string = yield authService.getToken();
    const response: {json: any} = yield call(httpGet,
      `${authService.appSettings.GetWebApiBaseUri()}/clientGroup/all`,
      token
    ); 
    const dealerGroups: DealerGroup[] = yield call([response, response.json]);
    yield put(loadAllDealerGroupsSuccess(dealerGroups));
  } catch (error) {
    yield put(displayError(error as string));
  }
}
export function* watchLoadAllDealerGroups() {
  yield takeLatest(LOAD_ALL_DEALER_GROUPS, loadAllDealerGroupsSaga);
}

// create dealer group
function* createDealerGroupSaga(action: CreateDealerGroupAction) {
  try {
    const token: string = yield authService.getToken();
    const response: {json: any} = yield call(httpPost, 
      `${authService.appSettings.GetWebApiBaseUri()}/clientGroup`,
      action.payload.dealerGroup, 
      token
    );
    const dealerGroup: DealerGroup = yield call([response, response.json]);
    yield put(createDealerGroupSuccess(dealerGroup));
  } catch (error) {
    yield put(displayError(error as string));
  }
}
export function* watchCreateDealerGroup() {
  yield takeLatest(CREATE_DEALER_GROUP, createDealerGroupSaga);
}

// update dealer group
function* updateDealerGroupSaga(action: UpdateDealerGroupAction) {
  try {
    const token: string = yield authService.getToken();
    const response: {json: any} = yield call(httpPut, 
      `${authService.appSettings.GetWebApiBaseUri()}/clientGroup`,
      action.payload.dealerGroup, 
      token
    );
    yield put(updateDealerGroupSuccess(action.payload.dealerGroup));
  } catch (error) {
    yield put(displayError(error as string));
  }
}
export function* watchUpdateDealerGroup() {
  yield takeLatest(UPDATE_DEALER_GROUP, updateDealerGroupSaga);
}

// Add Dealers to Dealer Group
function* addDealerToDealerGroupSaga(action: AddDealerToDealerGroupAction) {
  try {
    const token: string = yield authService.getToken();
    const response: {json: any} = yield call(httpPost, 
      `${authService.appSettings.GetWebApiBaseUri()}/clientGroup/clientPerformanceGroup`,
      {
        clientId: action.payload.dealerDealerGroup.dealerId,
        performanceGroupId: action.payload.dealerDealerGroup.dealerGroupId,
        memberName: action.payload.dealerDealerGroup.memberName,
        memberNumber: action.payload.dealerDealerGroup.memberNumber
      }, 
      token
    );

    yield put(addDealerToDealerGroupSuccess(action.payload.dealerDealerGroup));
  } catch (error) {
    yield put(displayError(error as string));
  }
}
export function* watchAddDealersToDealerGroup() {
  yield takeLatest(ADD_DEALER_TO_DEALER_GROUP, addDealerToDealerGroupSaga);
}

// Remove Dealer from Dealer Group
function* removeDealerFromDealerGroupSaga(action: RemoveDealerFromDealerGroupAction) {
  try {
    const token: string = yield authService.getToken();
    const response: {json: any} = yield call(httpDelete, 
      `${authService.appSettings.GetWebApiBaseUri()}/clientGroup/clientPerformanceGroup/${action.payload.dealerId}/${action.payload.dealerGroupId}`,
      token
    );
    yield put(removeDealerFromDealerGroupSuccess(action.payload.dealerId, action.payload.dealerGroupId));
  } catch (error) {
    yield put(displayError(error as string));
  }
}
export function* watchRemoveDealerFromDealerGroup() {
  yield takeLatest(REMOVE_DEALER_FROM_DEALER_GROUP, removeDealerFromDealerGroupSaga);
}

// update dealer dealer group member
function* updateDealerDealerGroupMemberSaga(action: UpdateDealerDealerGroupMemberAction) {
  try {
    const token: string = yield authService.getToken();
    const response: {json: any} = yield call(httpPut, 
      `${authService.appSettings.GetWebApiBaseUri()}/clientGroup/clientPerformanceGroup`,
      {
        clientId: action.payload.dealerDealerGroup.dealerId,
        performanceGroupId: action.payload.dealerDealerGroup.dealerGroupId,
        memberName: action.payload.dealerDealerGroup.memberName,
        memberNumber: action.payload.dealerDealerGroup.memberNumber
      },
      
      token
    );
    yield put(updateDealerDealerGroupMemberSuccess(action.payload.dealerDealerGroup));
  } catch (error) {
    yield put(displayError(error as string));
  }
}

export function* watchUpdateDealerDealerGroupMember() {
  yield takeLatest(UPDATE_DEALER_DEALER_GROUP_MEMBER, updateDealerDealerGroupMemberSaga);
}

export default function* dealerSagas() {
  yield all([
    watchCreateDealer(),
    watchUpdateDealer(),
    watchLoadAllDealers(),
    watchLoadAllDealerGroups(),
    watchCreateDealerGroup(),
    watchUpdateDealerGroup(),
    watchAddDealersToDealerGroup(),
    watchRemoveDealerFromDealerGroup(),
    watchUpdateDealerDealerGroupMember()
  ])
}
